export default __webpack_public_path__ + "static/media/Review.99e659ec.svg";